import { render, staticRenderFns } from "./ot-projects-layout.vue?vue&type=template&id=154cd8d7&scoped=true&"
import script from "./ot-projects-layout.vue?vue&type=script&lang=ts&"
export * from "./ot-projects-layout.vue?vue&type=script&lang=ts&"
import style0 from "./ot-projects-layout.vue?vue&type=style&index=0&id=154cd8d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154cd8d7",
  null
  
)

export default component.exports